import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import PdfIcon from 'core/components/customIcons/PdfIcon';
import WordIcon from 'core/components/customIcons/WordIcon';
import LoadingIconButton from 'core/components/LoadingIconButton';
import { getDocumentTypeExt, getDocumentTypeName } from 'core/utils/documentUtils';
import saveAs from 'file-saver';
import { isNil } from 'lodash';
import type { Document } from 'models/document/document';
import type { DocumentTypeEnum } from 'models/enums/documentTypeEnum';
import type { FC, ReactNode } from 'react';
import React, { useId, useState } from 'react';
import * as documentService from 'services/documentService';

const DownloadButton: FC<DownloadButtonProps> = (props) => {
  const { document, orderId } = props;

  const [downloading, setDownloading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const buttonId = useId();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    if (document.documentTypes.length === 1 && !isNil(document.documentTypes[0])) {
      download(document.documentTypes[0]);
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const download = (type: DocumentTypeEnum): void => {
    setDownloading(true);
    documentService
      .getDownloadDocumentAsync(document, orderId, type)
      .then((file) => {
        setDownloading(false);
        saveAs(file, `${document.name}${getDocumentTypeExt(type)}`);

        return downloading;
      })
      .catch((err) => {
        setDownloading(false);
        console.log(err);
      });
  };

  function getIconByDocType(t: DocumentTypeEnum): ReactNode {
    const icons = [<PdfIcon key='pdf' />, <WordIcon key='word' />];

    return icons[t];
  }

  return (
    <>
      <Tooltip title='Скачать'>
        <LoadingIconButton
          isLoading={downloading}
          id={buttonId}
          aria-controls={open ? `${buttonId}-menu` : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}>
          <FileDownloadOutlinedIcon />
        </LoadingIconButton>
      </Tooltip>
      <Menu
        id={`${buttonId}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': buttonId,
        }}>
        {document.documentTypes.map((t) => (
          <MenuItem
            sx={{ textTransform: 'uppercase' }}
            key={`doc-type-${t}`}
            onClick={() => {
              download(t);
              setAnchorEl(null);
            }}>
            <ListItemIcon>{getIconByDocType(t)}</ListItemIcon>
            <ListItemText>{getDocumentTypeName(t)}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

interface DownloadButtonProps {
  document: Document;
  orderId: number;
}

export default DownloadButton;
